import React from 'react';

import { defaultTextStyle } from 'settings/theme';

export default function Loader(props) {
    const {
        text,
    } = props;

    return (
        <div
            style={{
                marginTop: 20,
                marginBottom: 20,
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            <div
                style={{
                    ...defaultTextStyle,
                    fontSize: '1.3em',
                }}
            >
                {text}
            </div>
            <aside className="preloader-graphic" aria-live="polite" role="status">
                <span className="preloader-graphic-inner"></span>
            </aside>
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/components/vistaprintUILibrary/Loader.js